import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueHead from 'vue-head'
import p9 from './plugins/p9web'
import MQ from 'vue-match-media/src'
import VueObserveVisibility from 'vue-observe-visibility'
 
Vue.use(VueObserveVisibility)

Vue.use(MQ)

Vue.use( p9 )

Vue.prototype.$http = axios

Vue.use(VueLodash, { lodash: lodash })

Vue.use(VueHead)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  mq: {
    phone: '(max-width: 768px)',
    tablet: '(min-width: 769px) and (max-width: 1024px)',
    desktop: '(min-width: 1025px)'
  },
  render: function (h) { return h(App) }
}).$mount('#app')
